import echarts from "echarts"

const data = genData(10);
export default {
    total: {
        tooltip: {
            show: false,
            trigger: 'axis'
        },
        legend: {
            right: '3%',
            textStyle: {
                color: "#FFF"
            },
            data: ['申请数', '办结数']
        },
        grid: {
            left: '3%',
            top: '15%',
            width: '95%',
            height: "75%"
        },
        xAxis: [
            {
                type: 'category',
                data: [],
                axisLine: {
                    lineStyle: {
                        color: '#FFF'
                    }
                },
                axisLabel: {
                    interval: 0,//横轴信息全部显示
                    rotate: 0,// 倾斜角度
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                nameTextStyle: {
                    color: '#FFF'
                },
                axisLine: {
                    lineStyle: {
                        color: '#FFF'
                    }
                },
                splitLine: {
                    lineStyle: {
                        // 使用深浅的间隔色
                        color: ['#8EE3FF']
                    }
                }
            }
        ],
        series: [
            {
                name: '申请数',
                type: 'bar',
                barWidth: 20,
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#FDAA50'},
                                {offset: 1, color: '#FFCB59'}
                            ]
                        ),
                        barBorderRadius: [50, 50, 0, 0]
                    },
                },
                data: [

                ],
            },
            {
                name: '办结数',
                type: 'bar',
                barWidth: 20,
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#63A3E0'},
                                {offset: 1, color: '#1CC09E'}
                            ]
                        ),
                        barBorderRadius: [50, 50, 0, 0]
                    }
                },
                data: [

                ],
            }
        ]
    },
    analysis: {
        legend: {
            show: false,
        },
        series: [
            {
                name: '姓名',
                type: 'pie',
                radius: '55%',
                minAngle: 15,//最小角度
                startAngle: 270, //起始角度
                center: ['50%', '50%'],
                data: data.seriesData,
                labelLine: {
                    normal: {
                        length: 5,
                        lineStyle: {
                            color: "#FFFFFF",
                        },
                    },
                    lineStyle: {
                        color: "#FFFFFF",
                    },
                },
                label: {
                    normal: {
                        // formatter: '{b}\n: {c}',
                        formatter: function (params) {
                            let newParamsName = "";// 最终拼接成的字符串
                            let paramsNameNumber = params.name.length + 1;// 实际标签的个数
                            let provideNumber = 6;// 每行能显示的字的个数
                            let rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
                            if (rowNumber === 1) {
                                return params.name + '：' + params.value
                            }
                            for (let i=0; i < rowNumber; i++) {
                                let tempStr = "";// 表示每一次截取的字符串
                                let start = i * provideNumber;// 开始截取的位置
                                let end = start + provideNumber;// 结束截取的位置
                                if (i === rowNumber - 1) {
                                    tempStr = params.name.substring(start, paramsNameNumber);
                                } else {
                                    tempStr = params.name.substring(start, end) + "\n";
                                }
                                newParamsName += tempStr;
                            }
                            return newParamsName + '：' + params.value
                        },
                        textStyle: {
                            color: "#FFFFFF",  // 改变标示文字的颜色
                            fontSize: 15,
                        }
                    }
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    }
}

function genData(count) {
    // prettier-ignore
    const nameList = [
        '赵', '钱', '孙', '李', '周', '吴', '郑', '王', '冯', '陈', '褚', '卫', '蒋', '沈', '韩', '杨', '朱', '秦', '尤', '许', '何', '吕', '施', '张', '孔', '曹', '严', '华', '金', '魏', '陶', '姜', '戚', '谢', '邹', '喻', '柏', '水', '窦', '章', '云', '苏', '潘', '葛', '奚', '范', '彭', '郎', '鲁', '韦', '昌', '马', '苗', '凤', '花', '方', '俞', '任', '袁', '柳', '酆', '鲍', '史', '唐', '费', '廉', '岑', '薛', '雷', '贺', '倪', '汤', '滕', '殷', '罗', '毕', '郝', '邬', '安', '常', '乐', '于', '时', '傅', '皮', '卞', '齐', '康', '伍', '余', '元', '卜', '顾', '孟', '平', '黄', '和', '穆', '萧', '尹', '姚', '邵', '湛', '汪', '祁', '毛', '禹', '狄', '米', '贝', '明', '臧', '计', '伏', '成', '戴', '谈', '宋', '茅', '庞', '熊', '纪', '舒', '屈', '项', '祝', '董', '梁', '杜', '阮', '蓝', '闵', '席', '季', '麻', '强', '贾', '路', '娄', '危'
    ];
    const legendData = [];
    const seriesData = [];
    for (var i = 0; i < count; i++) {
        var name =
            Math.random() > 0.65
                ? makeWord(4, 1) + '·' + makeWord(3, 0)
                : makeWord(2, 1);
        legendData.push(name);
        seriesData.push({
            name: name,
            value: Math.round(Math.random() * 100000)
        });
    }
    return {
        legendData: legendData,
        seriesData: seriesData
    };

    function makeWord(max, min) {
        const nameLen = Math.ceil(Math.random() * max + min);
        const name = [];
        for (var i = 0; i < nameLen; i++) {
            name.push(nameList[Math.round(Math.random() * nameList.length - 1)]);
        }
        return name.join('');
    }
}
